import { FetchPolicy, useQuery } from '@apollo/client';

import { FeatureName } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import logger from 'helpers/logger';

import useCompanyContext from '../useCompanyContext';
import useMainBankAccountId from '../useMainBankAccountId';
import { ActivationOnboardingProgressDocument } from './ActivationOnboardingProgress.gql';

const useActivationOnboardingProgress = (options?: {
  fetchPolicy: FetchPolicy;
}) => {
  const { companyUserId } = useCompanyContext();
  const { canAccessFeature } = useCanCompanyUserAccessFeature();
  const { loading: bankAccountIdLoading, mainBankAccountId } =
    useMainBankAccountId();

  if (!mainBankAccountId && !bankAccountIdLoading) {
    logger.error(
      'mainBankAccountId is undefined in useActivationOnboardingProgress',
    );
  }

  if (!companyUserId) {
    logger.error(
      'companyUserId is undefined in useActivationOnboardingProgress',
    );
  }

  const { data, loading, refetch } = useQuery(
    ActivationOnboardingProgressDocument,
    {
      fetchPolicy: options?.fetchPolicy,
      skip:
        !canAccessFeature({
          name: FeatureName.Activationonboarding,
        }) ||
        !mainBankAccountId ||
        !companyUserId,
      variables: {
        bankAccountId: mainBankAccountId || '',
        companyUserId: companyUserId || '',
      },
    },
  );

  const activationOnboardingProgress =
    data?.bankAccount.activationOnboardingProgress;

  const { completed, done, skipped } = activationOnboardingProgress ?? {};

  return {
    completed,
    done,
    loading: bankAccountIdLoading || loading,
    refetch,
    skipped,
  };
};

export default useActivationOnboardingProgress;
